import { Handshake, LayoutDashboard, Wallet } from 'lucide-react'
import type { NavSectionKey } from '@/components/layout/navIconStyles'
import type { NavLinkItem } from '@/components/layout/sidebarNavItem'

export const PARCEIROS_HOME_PATH = '/parceiros/home'
export const PARCEIROS_INDICACOES_PATH = '/parceiros/indicacoes'
export const PARCEIROS_FINANCEIRO_PATH = '/parceiros/financeiro'

export type ParceirosNavSection = {
  label: string
  themeKey: NavSectionKey
  items: NavLinkItem[]
}

export const PARCEIROS_NAV: ParceirosNavSection[] = [
  {
    label: 'Principal',
    themeKey: 'commercial',
    items: [{ icon: LayoutDashboard, label: 'Dashboard', to: PARCEIROS_HOME_PATH, roles: ['indicador'] }],
  },
  {
    label: 'Indicações',
    themeKey: 'commercial',
    items: [{ icon: Handshake, label: 'Indicações', to: PARCEIROS_INDICACOES_PATH, roles: ['indicador'] }],
  },
  {
    label: 'Financeiro',
    themeKey: 'financeiro',
    items: [{ icon: Wallet, label: 'Comissões', to: PARCEIROS_FINANCEIRO_PATH, roles: ['indicador'] }],
  },
]
